import { styled } from '@linaria/react';

import { Text } from '~components/Typography';
import { MqTablet } from '~theme/media';

export const Container = styled.div`
	display: flex;
	width: 16px;
	height: 16px;
	flex-shrink: 0;
	border-radius: 100%;
	background-color: var(--color-azure-62-solid);
	box-shadow: var(--shadow-black);
	transition: transform 0.2s ease-in-out;

	&:empty {
		transform: scale(0);
	}

	${MqTablet} {
		background-color: var(--bot-color-main);
	}
`;

export const StyledP = styled(Text)`
	margin: auto;
	line-height: 0;
	text-shadow: 1px 1px 5px black;
	text-transform: uppercase;
`;
